// SectionComponent.js
import React, {useState, useEffect} from 'react';
import axios from 'axios';

const BASE_URL = 'https://cdn.mgazeti.co.ke/image_uploads/';

const replaceJpgWithWebp = (image) => {
    // console.log('loading image name ' + image);
    if (typeof image === 'string' && image.endsWith('.jpg')) {
        return image.replace('.jpg', '240.webp');
    }
    return image;
};

const SectionComponent = () => {
    const [sections, setSections] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        axios.get('/api/landing/sections')
            .then(response => {
                if (response.data.success) {
                    setSections(response.data.data);
                } else {
                    setError('Failed to fetch sections data');
                }
            })
            .catch(err => {
                setError(err.message);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    const preloaderDiv = (
        <div className="item-width content-card medium flex-column flex-align-center flex-vertical-center posr">
            <div className="width-f flex-nogrow item-height ovh z-depth-1 posr">
                <img
                    alt="loader image"
                    className="width-f hgt100p"
                    src="https://cdn.mgazeti.co.ke/image_uploads/skeleton-loader.gif"
                />
            </div>
        </div>
    );
    const preloaders = [];
    for (let i = 0; i < 5; i++) {
        preloaders.push(<div key={i}>{preloaderDiv}</div>);
    }

    if (loading) {
        return <div className="container-fluid width-f pl">
            <div className="container mg0tb flex flex-row flex-align-space-between ">
                <div className="width-f pl scrolling-wrapper scrollable-item gap-1 pg10b">{preloaders}</div>
            </div>
        </div>;
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    const renderArticles = (issues) => {

        return issues.map((issue, index) => {
            // console.log('Loading articles: ', issue);
            const updatedUrl = replaceJpgWithWebp(issue.image);

            return (
                <div key={index} className="article-in-card">
                    <div className="article-in-card-div">
                        <h3 className="article-info mg10b">
                            <span className="article-publication">{issue.issue.publication.title}</span>
                            <span>{issue.issue.title}</span>
                        </h3>
                        <div className="article-content">

                            <a href={`/explore/${issue.id}`} title={issue.name} aria-label={issue.name}
                               className="mg10b article-title">

                            </a>
                            <div className="article-excerpt-container">
                                <p className="article-excerpt">
                                    {issue.excerpt}
                                </p>
                                <div className="article-image-small">

                                    <div className="width90x hgt100x">
                                        <img className="width-f hgt100p lazyloaded" fetchpriority="high"
                                             src={`${BASE_URL}${updatedUrl}`}/>
                                    </div>


                                </div>
                            </div>
                        </div>
                        <div className="article-time" size="16" role="presentation" data-cynio="icon-name-schedule">
                            <span>{issue.reading_time} min</span>
                        </div>
                    </div>
                </div>
            );
        });
    };


    const renderIssues = (issues) => {
        return issues.map((issue, index) => {
            // console.log('Loading issues: ' + index, issue);
            const updatedUrl = replaceJpgWithWebp(issue.cover_image);
            return (
                <a key={index} href={`/issue/${issue.slug}/details`}
                   className="flex-nogrow mg0lr pl item-width content-card medium">
                    <div className="width-f hgt100 flex-column flex-align-center flex-vertical-center posr">
                        <div className="width-f flex-nogrow item-height medium  z-depth-1 posr mg5t">
                            <img className="width-f hgt100p  pl posr" src={`${BASE_URL}${updatedUrl}`}
                                 alt={`Issue ${index + 1}`}/>
                        </div>

                        <div className="flex-grow pg10lr pg16t pg10b width-f card-title-shadow">
                            <p className="card-title mg5b">{issue.publication.title}</p>
                            <span className="cr66 light card-subtitle">
                            {issue.title}
                        </span>
                        </div>
                    </div>

                </a>
            );
        });
    };

    return (

        <div className="container-fluid width-f pl ">
            {Object.keys(sections).map((key, index) => {
                const sectionData = sections[key];
                const containerClass = sectionData.title === 'articles'
                    ? 'container-fluid width-f pl bgf4'
                    : 'container-fluid width-f pl';
                return (
                    <div className={containerClass} key={index}>
                        <div className="container mg0tb pg0lr">
                            <div className="width-f flex-row flex-align-space-between flex-vertical-end mg20tb">
                                <div className="flex-nogrow mg20r">
                                    <h2 className="cap semi-bold cr37 mg0tb">
                                        {sectionData.title}
                                    </h2>
                                </div>
                                <div className="flex-nogrow">

                                    <a href={sectionData.link} className="mg10lr cap cr66">
                                        See All <i className="fas fa-chevron-right mg0l"></i>
                                    </a>

                                </div>
                            </div>

                            <div className="width-f pl">
                                <div className="width-f flex-row flex-align-start flex-vertical-end mg10tb d-block">
                                    <div className="width-f pl scrolling-wrapper scrollable-item gap-1 pg10b">

                                        {sectionData.title === "articles" ? (
                                            <div
                                                className="width-f flex-row flex-align-start flex-vertical-end mg10tb d-block">
                                                <div className="article-container width-f">
                                                    {renderArticles(sectionData.issues)}
                                                </div>
                                            </div>

                                        ) : (
                                            sectionData.issues.length > 0 ? (
                                                renderIssues(sectionData.issues)
                                            ) : (
                                                <p>No issues available</p>
                                            )
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default SectionComponent;
